/**
 *  @class
 *  @function ThemeCart
 */
if (!customElements.get('theme-cart')) {
  class ThemeCart extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this._onCartRefresh = () => this.refresh();
      this._onCartRemove = (event) => this.updateQuantity(event.detail.key, '0', event.detail.index);
      this._onNotesChange = this.onNotesChange.bind(this);
      this._debouncedOnFormChange = debounce((event) => {
        this.onFormChange(event);
      }, 300);

      this.form = this.querySelector('#cart-form');
      this.notes = this.querySelector('#CartSpecialInstructions');

      document.addEventListener('cart:refresh', this._onCartRefresh);
      document.addEventListener('cart:remove', this._onCartRemove);
      this.notes?.addEventListener('change', this._onNotesChange);
      this.form?.addEventListener('change', this._debouncedOnFormChange);
    }
    disconnectedCallback() {
      document.removeEventListener('cart:refresh', this._onCartRefresh);
      document.removeEventListener('cart:remove', this._onCartRemove);
      this.notes?.removeEventListener('change', this._onNotesChange);
      this.form?.removeEventListener('change', this._debouncedOnFormChange);
    }
    onFormChange(event) {
      this.updateQuantity(event.target.dataset.key, event.target.value, event.target.dataset.index);
    }
    onNotesChange() {
      this.saveNotes();
    }
    saveNotes() {
      const note = this.notes.value;
      const request = fetch(`${theme.routes.cart_update_url}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': `application/json`
        },
        body: JSON.stringify({
          'note': note
        })
      });
      publishStandardEvent('CartNoteUpdateEvent', {
        context: 'cart',
        note: note,
        promise: request
          .then((response) => response.json())
          .then((cart) => ({ cart: standardEventCart(cart) }))
          .catch(() => ({ cart: null }))
      });
    }
    rebindFormListeners() {
      this.form = this.querySelector('#cart-form');
      this.notes = this.querySelector('#CartSpecialInstructions');
      this.notes?.addEventListener('change', this._onNotesChange);
      this.form?.addEventListener('change', this._debouncedOnFormChange);
    }
    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form--count'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-secondary-area--item-count'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-secondary-area--item-amount'
      }];
    }
    displayErrors(line, message) {
      const lineItemError =
        document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
      if (lineItemError) {
        lineItemError.removeAttribute('hidden');
        lineItemError.querySelector('.cart-item__error-text').innerHTML = message;
        this.form.querySelector(`#CartItem-${line}`).classList.remove('loading');

        this.rebindFormListeners();
      }
    }
    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
    // key: the line item key (item.key) — targets the line wherever it sits in the
    // cart, even after apps or discounts add/remove lines. line: the 1-based index
    // the page was rendered with, used only for DOM lookups (#CartItem-N etc.).
    updateQuantity(key, quantity, line) {

      this.form.classList.add('cart-disabled');
      if (line) {
        this.form.querySelector(`#CartItem-${line}`).classList.add('loading');
      }

      const body = JSON.stringify({
        id: key,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      });
      dispatchCustomEvent('line-item:change:start', {
        quantity: quantity
      });
      fetch(`${theme.routes.cart_change_url}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': `application/json`
        },
        ...{
          body
        }
      })
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);


          if (parsedState.errors) {
            this.displayErrors(line, parsedState.errors);
            this.form.classList.remove('cart-disabled');
            publishStandardEvent('CartErrorEvent', standardEventCartError(parsedState.errors));
            return;
          }

          this.renderContents(parsedState, line, false);

          // The empty-cart markup has no #cart-form, so the rebound form can be null.
          this.form?.classList.remove('cart-disabled');

          dispatchCustomEvent('line-item:change:end', {
            key: key,
            context: 'cart',
            quantity: quantity,
            cart: parsedState
          });
        });
    }
    refresh() {
      this.form.classList.add('cart-disabled');

      let sections = 'main-cart';

      fetch(`${window.location.pathname}/?sections=${sections}`)
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);


          if (parsedState.errors) {
            this.displayErrors(line, parsedState.errors);
            this.form?.classList.remove('cart-disabled');
            return;
          }

          this.renderContents(parsedState, false, true);

          this.form?.classList.remove('cart-disabled');
        });
    }
    renderContents(parsedState, line, refresh) {
      this.getSectionsToRender().forEach((section => {
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

        if (refresh) {
          if (parsedState[section.section]) {
            elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState[section.section], section.selector);
          }
        } else {
          if (parsedState.sections?.[section.section]) {
            elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
          }
        }
        this.rebindFormListeners();

        if (line && this.form?.querySelector(`#CartItem-${line}`)) {
          this.form.querySelector(`#CartItem-${line}`).classList.remove('loading');
        }
      }));
    }
  }
  customElements.define('theme-cart', ThemeCart);
}